export default "__VITE_ASSET__DYWh$RBu__"